var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _c("breadcrumb", {
        staticClass: "breadcrumb-container",
        attrs: { id: "breadcrumb-container" },
      }),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _c(
                  "el-row",
                  {
                    staticStyle: {
                      position: "relative",
                      top: "-15px",
                      "font-size": "14px",
                      "margin-right": "15px",
                      display: "inline-block",
                      "padding-bottom": "2px",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.tenantIdName) + " ")]
                ),
                _vm.isEnableChangeDept
                  ? _c(
                      "el-row",
                      {
                        staticStyle: {
                          position: "relative",
                          top: "-15px",
                          "font-size": "14px",
                          "margin-right": "15px",
                          display: "inline-block",
                          "padding-bottom": "2px",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "部门" },
                            on: { change: _vm.changeDept },
                            model: {
                              value: _vm.deptName,
                              callback: function ($$v) {
                                _vm.deptName = $$v
                              },
                              expression: "deptName",
                            },
                          },
                          _vm._l(_vm.deptList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.deptName,
                                value: item.deptId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-row",
                  {
                    staticStyle: {
                      position: "relative",
                      top: "-15px",
                      "font-size": "14px",
                      "margin-right": "15px",
                      display: "inline-block",
                      "padding-bottom": "2px",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.nickName) + " ")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "right-menu-item",
                    staticStyle: {
                      display: "inline-flex",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: "/record" } },
                      [
                        _c(
                          "el-badge",
                          {
                            staticStyle: { display: "inline-flex" },
                            attrs: {
                              hidden: _vm.messageNumber <= 0,
                              value: _vm.messageNumber,
                            },
                          },
                          [_c("i", { staticClass: "el-icon-message-solid" })]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("search", {
                  staticClass: "right-menu-item",
                  attrs: { id: "header-search" },
                }),
                _c("screenfull", {
                  staticClass: "right-menu-item hover-effect",
                  attrs: { id: "screenfull" },
                }),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "布局大小",
                      effect: "dark",
                      placement: "bottom",
                    },
                  },
                  [
                    _c("size-select", {
                      staticClass: "right-menu-item hover-effect",
                      attrs: { id: "size-select" },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("img", {
                  staticClass: "user-avatar",
                  attrs: { src: _vm.avatar },
                }),
                _c("i", { staticClass: "el-icon-caret-bottom" }),
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/user/profile" } },
                    [_c("el-dropdown-item", [_vm._v("个人中心")])],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          _vm.setting = true
                        },
                      },
                    },
                    [_c("span", [_vm._v("布局设置")])]
                  ),
                  !_vm.isAdmin
                    ? _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.switchDept($event)
                            },
                          },
                        },
                        [_c("span", [_vm._v("切换组织")])]
                      )
                    : _vm._e(),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout($event)
                        },
                      },
                    },
                    [_c("span", [_vm._v("退出登录")])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: "切换组织",
            visible: _vm.open,
            width: "300px",
            "lock-scroll": true,
            "modal-append-to-body": false,
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { height: "300px" } },
            [
              _c(
                "el-form",
                { ref: "form", attrs: { model: _vm.form } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        placeholder: "请输入关键词",
                      },
                      model: {
                        value: _vm.form.tenantId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "tenantId", $$v)
                        },
                        expression: "form.tenantId",
                      },
                    },
                    _vm._l(_vm.tenantList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取 消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }